import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { HttpUtils } from '../utils/httpUtils';
import { SensorData } from '../model/sensorData';

@Injectable({
  providedIn: 'root'
})
export class AttachmentQualificatesService {

  constructor(private http: HttpClient
  ) { }

  uploadGeneric(file: File, idType: number = 99): Observable<any> {
    const url = environment.qualificatesUrl + '/attachment/';
    const form = new FormData();
    form.append('file', file, file.name);
    form.append('idType', idType.toString());

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadAttachmentToTest(idProtocol: number, idTest: number, file: File): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolQTestAttachment/protocol/${idProtocol}/test/${idTest}`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadAttachmentToProtocol(idProtocol: number, file: File): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolAttachment/protocol/${idProtocol}`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadAttachmentToExecution(idExecution: number, file: File): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/execution/${idExecution}`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadAttachmentToExecutionTest(idExecution: number, idTest: number, file: File): Observable<any> {
    const url = environment.qualificatesUrl + `/executionQTestAttachment/execution/${idExecution}/test/${idTest}`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadAttachmentToDeviation(idDeviation: number, file: File): Observable<any> {
    const url = environment.qualificatesUrl + `/deviation/${idDeviation}`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  getAllTypesForProtocolAir(): Observable<any> {
    const url = environment.coreUrl + '/attachment/types/protocol';

    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  getAllTypesForExecution(): Observable<any> {
    const url = environment.coreUrl + '/attachment/types/execution';

    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  updateAttachmentToTest(id: number, idProtocol: number, idTest: number, idAttachment: number, idType: number, name: string): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolQTestAttachment/protocol/test/attachment/${idAttachment}`;

    const body = {
      id,
      idProtocol,
      idTest,
      idAttachment, idType, name
    };

    return this.http.post(url, body).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  updateAttachmentToProtocol(idProtocol: number, idAttachment: number, idType: number, name: string): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolAttachment/attachment/${idAttachment}`;

    const body = {
      idProtocol: idProtocol,
      idAttachment: idAttachment,
      idType: idType,
      name: name
    };

    return this.http.post(url, body).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  updateAttachmentToExecution(idExecution: number, idAttachment: number, idType: number, name: string): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/attachment/${idAttachment}`;

    const body = {
      idExecution: idExecution,
      idAttachment: idAttachment,
      idType: idType,
      name: name
    };

    return this.http.post(url, body).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  updateAttachmentToExecutionTest(id: number, idExecution: number, idTest: number, idAttachment: number, idType: number, name: string): Observable<any> {
    const url = environment.qualificatesUrl + `/executionQTestAttachment/test/attachment/${idAttachment}`;

    const body = {
      id,
      idExecution,
      idTest,
      idAttachment, idType, name
    };

    return this.http.post(url, body).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  downloadAttachmentToTest(idTest: number, idAt: number): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolQTestAttachment/protocol/test/${idTest}/attachment/${idAt}`;

    return this.http.get(url, { responseType: 'blob' });
  }

  downloadAttachmentToProtocol(idProtocol: number, idAt: number): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolAttachment/protocol/${idProtocol}/attachment/${idAt}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  downloadAttachmentToExecution(idExecution: number, idAt: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/execution/${idExecution}/attachment/${idAt}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  downloadAttachmentToExecutionTest(idTest: number, idAt: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionQTestAttachment/test/${idTest}/attachment/${idAt}`;

    return this.http.get(url, { responseType: 'blob' });
  }

  downloadAttachmentToDeviation(idAt: number): Observable<any> {
    const url = `${environment.qualificatesUrl}/deviation/download/${idAt}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  deleteAttachmentToTest(idTest: number, idAttachment: number): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolQTestAttachment/protocol/test/${idTest}/attachment/${idAttachment}`;

    return this.http.delete(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  deleteAttachmentToProtocol(idProtocol: number, idAttachment: number): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolAttachment/protocol/${idProtocol}/attachment/${idAttachment}`;

    return this.http.delete(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  deleteAttachmentToExecution(idExecution: number, idAttachment: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/execution/${idExecution}/attachment/${idAttachment}`;

    return this.http.delete(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  deleteAttachmentToDeviation(idAttachment: number, idDeviation: number): Observable<any> {
    const url = environment.qualificatesUrl + `/deviation/delete/${idDeviation}/attachment/${idAttachment}`;

    return this.http.delete(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  deleteAttachmentToExecutionTest(idTest: number, idAttachment: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionQTestAttachment/execution/test/${idTest}/attachment/${idAttachment}`;

    return this.http.delete(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  getImageToVerification(id: number): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolQTestAttachment/protocol/itemVerification/${id}`;
    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadImageToVerificationWithXY(id: number, idProtocol: number, idProtocolQTest: number, file: File, width: number, height: number): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolQTestAttachment/protocol/${idProtocol}/${idProtocolQTest}/itemVerification/${id}/${width}/${height}`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadImageToVerification(id: number, idProtocol: number, idProtocolTest: number, file: File): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolQTestAttachment/protocol/${idProtocol}/${idProtocolTest}/itemVerification/${id}`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadImageToDataMultiple(idDataMultiple: number, idProtocolTest: number, idProtocol: number, idItemVerificacion: number, file: File): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolQTestAttachment/protocol/${idProtocol}/${idProtocolTest}/itemVerification/${idItemVerificacion}/${idDataMultiple}/expectedResult`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadGeneralPhoto(idExecutionTest: number, idEssay: number, file: File): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/test/${idExecutionTest}/essay/${idEssay}/photo`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadPhotoToSensor(idSensor: number, file: File): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/sensor/${idSensor}/photo`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  rotateSensorImageLeft(idSensor: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/sensor/${idSensor}/rotate/left`;

    return this.http.post(url, {}).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  rotateSensorImageRight(idSensor: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/sensor/${idSensor}/rotate/right`;

    return this.http.post(url, {}).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadPrimaryFileToSensor(idSensor: number, file: File): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/sensor/${idSensor}/primary`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadExcelToSensor(idSensor: number, file: File, data: SensorData[]): Observable<any> {

    data = data.filter(item => item.date != null && !isNaN(item.date.getTime()) && item.value != null);

    const dataCopy = data.map(a => ({ ...a }));
    dataCopy.forEach(d => {
      delete d.idVariable;
      delete d.equipmentName;
      delete d.serialNum;
      delete d.idEquipment;
    });

    const url = environment.qualificatesUrl + `/executionAttachment/sensor/${idSensor}/excel`;
    const form = new FormData();
    form.append('file', file, file.name);
    form.append('data', JSON.stringify(dataCopy));

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  convertExcelToCsv(file: File): Observable<any> {
    const url = environment.qualificatesUrl + '/executionAttachment/sensor/excel/convertExcelToCsv';
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form, { responseType: 'blob' });
  }

  convertPdfToCsv(file: File, idVariable: number): Observable<any> {
    const url = environment.qualificatesUrl + '/executionAttachment/sensor/pdf/convertPdfToCsv';
    const form = new FormData();
    form.append('file', file, file.name);
    form.append('idVariable', idVariable.toString());

    return this.http.post(url, form, { responseType: 'blob' });
  }

  uploadAttachmentToTestAndType(idExecution: number, idTest: number, file: File, type: number = 99): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/execution/${idExecution}/test/${idTest}/attachment`;
    const form = new FormData();
    form.append('file', file, file.name);

    if (type != null) {
      form.append('type', type.toString());
    }

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  getAttachmentInfoToEssay(idExecutionTest: number, idEssay: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/test/${idExecutionTest}/essay/${idEssay}/info`;

    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  getAttachmentInfoToSensor(idSensor: number, idAttachment: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/sensor/${idSensor}/info/${idAttachment}`;

    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  downloadPhotoToEssay(idExecutionTest: number, idEssay: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/test/${idExecutionTest}/essay/${idEssay}/photo`;
    return this.http.get(url, { responseType: 'blob' });
  }

  downloadAttachmentToSensor(idSensor: number, idAttachment: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/sensor/${idSensor}/file/${idAttachment}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  deleteAttachmentToSensor(idSensor: number, idAttachment: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/sensor/${idSensor}/file/${idAttachment}`;
    return this.http.delete(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  downloadCertificateBioindicatorEquipment(idCertificate: number): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/bioindicator/equipment/${idCertificate}/certificate`;

    return this.http.get(url, { responseType: 'blob' });
  }

  uploadCertificateToCriticalInstrumentation(id: number, file: File): Observable<any> {
    const url = environment.qualificatesUrl + `/executionAttachment/criticalInstrumentation/${id}/certificate`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  uploadImageToDataMultipleWithXY(idDataMultiple: number, idProtocol: number, idProtocolQTest: number, idItemVerification: number, file: File, width: number, height: number): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolQTestAttachment/protocol/${idProtocol}/${idProtocolQTest}/itemVerification/${idItemVerification}/${idDataMultiple}/${width}/${height}/expectedResult`;
    const form = new FormData();
    form.append('file', file, file.name);

    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }


  getImageToDataMultiple(id: number): Observable<any> {
    const url = environment.qualificatesUrl + `/protocolQTestAttachment/protocol/test/dataMultiple/${id}`;
    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

}
